import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { saveAs } from "file-saver";
//--------------------------------------------------------------------------------------------
import Resize from "src/components/common/resize";
import UserInfo from "src/components/common/userInfo";
import { useMyStore } from "src/components/main/mainStore";
import StandbyForm from "src/components/outside/standby/standbyForm";

import {
    getDateEndFromWeekNum, 
    buildWeekNumArray, 
    mimeTypeMap, 
    weeknum, 
    MyDate, 
    changeWeek, 
    getTimeStamp, 
    myAxios, 
    MyFormData, 
    descSort, 
    isDevMode, 
    outsideCordinators, 
    standbyStartDate as startDate,
    appTitle, 
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function StandbyTimeCard({ tabTitle }){
    const history = useHistory();
    const path = history.location.pathname;
    const path1 = path.split("/")[1];
    const path2 = path.split("/")[2];
    //--------------------------------------------------------------------------------------------
    const user = useMyStore(state => state.user);
    const [weeks] = useState(buildWeekNumArray(
        user.hireDate > startDate?user.hireDate: startDate,
        user.quitDate && new Date() > new Date(user.quitDate.replace(/-/g, "/"))?user.quitDate:((new MyDate()).s())
    ).reverse());
    const [week, setWeek] = useState((() => !weeks.includes(path2)?weeknum((new MyDate()).s()):path2));
    //--------------------------------------------------------------------------------------------
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const forms = useMyStore((state) => state.outsideserviceStandbyForms);
    const setForms = useMyStore((state) => state.setOutsideserviceStandbyForms);
    //--------------------------------------------------------------------------------------------
    const curForms = forms[week] ?? [];
    //--------------------------------------------------------------------------------------------
    const [updateDateTime, setUpdateDateTime] = useState({
        "Forms": forms.updatedAt === null?getTimeStamp():forms.updatedAt
    });
    //--------------------------------------------------------------------------------------------
    const [showLoading, setShowLoading] = useState(false);
    //--------------------------------------------------------------------------------------------
    const today = new MyDate();
    const late = ((weeknum(today)) > changeWeek(week, 1)) || (
        (weeknum(today)) > week && 
        (
            ((today.getDay() === 1) && today.getHours() >= 8)
            || (today.getDay() > 1 || today.getDay() === 0)
        )
    ); // by Monday 8AM
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        if(isDevMode) console.log("useEffect");
        let isMounted = true;
        const getData = async () => {
            const formData = new MyFormData();
            //----------------------------
            if(changeWeek(week, -1) !== "w2023-28"){
                formData.append("weeks", `\`standby\`.\`${week}\`,\`standby\`.\`${changeWeek(week, -1)}\``);
            }else{
                formData.append("weeks", `\`standby\`.\`${week}\``);
            }
            setShowLoading(true);
            const res = await myAxios("outside/standby/readTimeCard.php", formData);
            if(!isMounted) return;
            setShowLoading(false);
            if(!res) return;
            //----------------------------
            const unordered = res.data;
            delete unordered.email;
            const ordered = Object.keys(unordered).sort(descSort).reduce(
            (obj, key) => { 
                obj[key] = JSON.parse(unordered[key] || "{}");
                return obj;
            }, 
            {}
            );
            const forms = Object.entries(ordered).map(([key, value]) => ({...value, week: key})) || [];
            setForms(week, forms, updateDateTime["Forms"]);
            if(!forms.find(form => form.week === week) || forms.find(form => form.week === week).status === "Submitted"){
                history.push(`/${path1}`);
            }
        }
        if(!forms[week] || (updateDateTime["Forms"] !== forms.updatedAt)) getData();
        return () => {
            isMounted = false;
        }
    },[history, week, updateDateTime["Forms"]])
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //--------------------------------------------------------------------------------------------
    return(
        <div className = "personel">
            <div className = "projectHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    Time Card
                    <span
                        data-toggle = "tooltip"
                        title = {`Refreshed on ${Object.values(updateDateTime)[0]}.`}
                        className = "btn btn-primary py-1 ml-4"
                        onClick = {() => {
                            const timeStamp = getTimeStamp();
                            setUpdateDateTime(Object.fromEntries(Object.keys(updateDateTime).map(key => [key, timeStamp])));
                        }}
                    >
                        ↻
                    </span>
                </span>
                {weeks.length?
                <span>
                    <span className = "mx-2">Week</span>
                    <select
                        className = "form-control inline"
                        value = {week}
                        onChange = {e => setWeek(e.currentTarget.value)}
                    >
                        {weeks.map((k, key) => <option key = {key} value = {k}>{getDateEndFromWeekNum(k)}</option>)}
                    </select>
                </span>
                :<></>}
            </div>
            <div>
                <div>
                    <div className = "table-responsive">
                        <table className = "table">
                            <thead>
                                <tr className = "noBorderTop">
                                    {curForms.find(form => form.week === week)?.status !== "Submitted" || !late?
                                    <th></th>
                                    :<></>}
                                    <th>Week</th>
                                    {curForms.find(form => form.week === week)?.status !== "Submitted" || !late?<></>:
                                    <th>Submit Time</th>
                                    }
                                    <th>Status</th>
                                    {curForms.find(form => form.week === week)?.status !== "Submitted" || !late?<></>:
                                    <th>Excels</th>
                                    }
                                </tr>
                                </thead>
                                <tbody>
                                    {showLoading?
                                        <tr><td colSpan = {100} className = "text-center pt-5 h5">Loading...</td></tr>
                                        :
                                        (curForms.length === 0?
                                            <tr><td colSpan = {100} className = "text-center h5 pt-5">No Time Card Yet...</td></tr>
                                            :
                                            <>
                                            {curForms.filter(form => form.week === week).map((form, formIndex) => 
                                            <tr
                                                id = {form.week}
                                                key = {formIndex}
                                                className = {curForms.find(form => form.week === week)?.status !== "Submitted" || !late?"pointer":""}
                                                onClick = {e => {
                                                    if(!e.target.id && (curForms.find(form => form.week === week)?.status !== "Submitted" || !late)){
                                                        if(path2 !== e.currentTarget.id){
                                                            history.push(`/${path1}/${e.currentTarget.id}`);
                                                        }else{
                                                            history.push(`/${path1}`);
                                                        }
                                                    }
                                                }}
                                            >
                                                {form.status !== "Submitted" || !late?
                                                <td className = {week === form.week?"showMinus":"showPlus"}></td>
                                                :<></>}
                                                <td>
                                                    <strong>
                                                        {getDateEndFromWeekNum(form.week)}
                                                    </strong>
                                                </td>
                                                {form.status !== "Submitted" || !late?<></>:
                                                <td>
                                                    <span>
                                                        {form.submitTime}
                                                    </span>
                                                </td>
                                                }
                                                <td>
                                                    <span>
                                                        {form.status}
                                                    </span>
                                                </td>
                                                {form.status === "Submitted" || !late?<td>
                                                    {form.id?
                                                    <span
                                                        id = {form.id}
                                                        className = "btn btn-primary"
                                                        onClick = {async() => {
                                                            const formData = new MyFormData();
                                                            formData.append("fileId", form.id);
                                                            //----------------------------
                                                            setShowLoader(true);
                                                            const res = await myAxios("outside/standby/getExcel.php", formData, "blob");
                                                            setShowLoader(false);
                                                            if(!res) return;
                                                            //----------------------------
                                                            const file = new Blob([res.data], {type: mimeTypeMap.xlsx});
                                                            saveAs(file, `${form.week}.xlsx`);
                                                        }}
                                                    >
                                                        Payroll
                                                    </span>:<></>}
                                                    {form.billableId?
                                                    <span
                                                        id = {form.billableId}
                                                        className = "ml-3 btn btn-success"
                                                        onClick = {async() => {
                                                            const formData = new MyFormData();
                                                            formData.append("fileId", form.billableId);
                                                            //----------------------------
                                                            setShowLoader(true);
                                                            const res = await myAxios("outside/standby/getExcel.php", formData, "blob");
                                                            setShowLoader(false);
                                                            if(!res) return;
                                                            //----------------------------
                                                            const file = new Blob([res.data], {type: mimeTypeMap.xlsx});
                                                            saveAs(file, `${form.week} billable.xlsx`);
                                                        }}
                                                    >
                                                        Billable
                                                    </span>:<></>}
                                                </td>
                                                :<></>}
                                            </tr>
                                            )}
                                            </>
                                        )
                                    }
                            </tbody>
                        </table>
                        {!showLoading && curForms.length > 0 && !(curForms.find(form => form.week === week)?.status !== "Submitted" || !late)?
                        <tr className = "text-danger font-weight-bold h4">
                            Submission window is closed for selected week. Please contact&nbsp;
                            {outsideCordinators.map(outsideCordinator => <UserInfo {...outsideCordinator}/>)}
                            &nbsp;for any edits.
                        </tr>
                        :<></>}
                    </div>
                </div>
            </div>
            {curForms.find(form => form.week === path2) && (curForms.find(form => form.week === week).status !== "Submitted" || !late)?
            <StandbyForm 
                closeIt = {() => {history.push(`/${path1}`)}}
                defaultData = {curForms.find(form => form.week === week)}
                prevData = {curForms.find(form => form.week === changeWeek(week, -1))}
                week = {week}
            />
            :<></>}
        </div>
    )
}